import DashboardClientLayout from "../../Layouts/DashboardClientLayout";
import "./HomePage.css";

function ChevronIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="m9 6 6 6-6 6" />
    </svg>
  );
}

function ShieldIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 3.5 19 6.4v5.2c0 4.4-3 7.8-7 9.4-4-1.6-7-5-7-9.4V6.4L12 3.5Z" />
      <path d="m8.5 12.1 2.4 2.4 4.8-5" />
    </svg>
  );
}

function LockIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <rect x="5" y="10" width="14" height="10" rx="2.5" />
      <path d="M8 10V7.8A4 4 0 0 1 12 4a4 4 0 0 1 4 3.8V10" />
    </svg>
  );
}

function DeviceIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <rect x="6" y="3.5" width="12" height="17" rx="2.5" />
      <path d="M10 18h4" />
    </svg>
  );
}

function KeyIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="9" cy="12" r="3" />
      <path d="M12 12h7l-2 2 2 2" />
    </svg>
  );
}

function MailIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <rect x="4" y="6" width="16" height="12" rx="2.5" />
      <path d="m5.5 8.5 6.5 5 6.5-5" />
    </svg>
  );
}

function PhoneIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M7.5 4.5h2L11 8l-1.8 1.8a13 13 0 0 0 4 4L15 12l3.5 1.5v2a2 2 0 0 1-2 2A12.5 12.5 0 0 1 4.5 7.5a2 2 0 0 1 2-2Z" />
    </svg>
  );
}

function HelpIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 15.2v.3M9.8 9.8a2.5 2.5 0 1 1 4.4 1.7c-.9.8-1.8 1.2-1.8 2.5" />
    </svg>
  );
}

function WarningIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="m12 4 9 16H3L12 4Z" />
      <path d="M12 9v4M12 16.5v.3" />
    </svg>
  );
}

function CardIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <rect x="4" y="6" width="16" height="12" rx="2.5" />
      <path d="M4 10h16" />
    </svg>
  );
}

function CheckCircleIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="12" r="8.5" />
      <path d="m8.8 12.1 2.1 2.1 4.4-4.8" />
    </svg>
  );
}

function SectionRow({ icon, title, desc, trailing, status, action }) {
  const Icon = icon;
  return (
    <div className="sec-row">
      <span className="sec-row-icon">
        <Icon />
      </span>
      <div className="sec-row-copy">
        <strong>{title}</strong>
        <small>{desc}</small>
      </div>
      {status ? <span className="sec-status">{status}</span> : null}
      {trailing ? <span className="sec-row-value">{trailing}</span> : null}
      {action ? <button type="button" className="sec-row-btn">{action}</button> : null}
      <span className="sec-row-chevron" aria-hidden="true">
        <ChevronIcon />
      </span>
    </div>
  );
}

function ActivityItem({ icon, title, location, time, status, tone }) {
  const Icon = icon;
  return (
    <div className="sec-activity-row">
      <span className={`sec-activity-icon ${tone}`}>
        <Icon />
      </span>
      <div className="sec-activity-copy">
        <strong>{title}</strong>
        <span>{location}</span>
        <small>{time}</small>
      </div>
      {status ? <span className={`sec-activity-pill ${tone}`}>{status}</span> : null}
    </div>
  );
}

function ShieldBackdrop() {
  return (
    <div className="sec-backdrop" aria-hidden="true">
      <div className="sec-backdrop-orb sec-orb-a" />
      <div className="sec-backdrop-orb sec-orb-b" />
      <div className="sec-backdrop-orb sec-orb-c" />
      <div className="sec-backdrop-shield">
        <ShieldIcon />
      </div>
    </div>
  );
}

export default function SecurityClient() {
  return (
    <>
      <div className="sec-hero">
        <h1>Sécurité</h1>
        <p>Protégez votre compte et vos informations personnelles.</p>
      </div>

      <div className="sec-layout">
        <section className="sec-main">
          <article className="sec-card">
            <div className="sec-card-head">
              <span className="sec-head-icon">
                <ShieldIcon />
              </span>
              <h2>Sécurité du compte</h2>
            </div>

            <div className="sec-rows">
              <SectionRow icon={LockIcon} title="Mot de passe" desc="Changez votre mot de passe régulièrement pour protéger votre compte." action="Modifier" />
              <SectionRow icon={ShieldIcon} title="Authentification à deux facteurs (2FA)" desc="Ajoutez une couche de sécurité supplémentaire à votre compte." status="Activée" />
              <SectionRow icon={DeviceIcon} title="Sessions actives" desc="Gérez les appareils sur lesquels votre compte est connecté." action="Gérer" />
              <SectionRow icon={DeviceIcon} title="Appareils de confiance" desc="Consultez et gérez vos appareils de confiance." action="Voir" />
            </div>
          </article>

          <article className="sec-card">
            <div className="sec-card-head">
              <span className="sec-head-icon">
                <CheckCircleIcon />
              </span>
              <h2>Vérification et protection</h2>
            </div>

            <div className="sec-rows">
              <SectionRow icon={MailIcon} title="E-mail de récupération" desc="Maintenez votre e-mail de récupération à jour." trailing="jean.martin@email.com" />
              <SectionRow icon={PhoneIcon} title="Numéro de téléphone" desc="Votre numéro est utilisé pour sécuriser votre compte." trailing="+237 6XX XXX XXX" />
              <SectionRow icon={HelpIcon} title="Questions de sécurité" desc="Répondez à vos questions de sécurité pour récupérer votre compte." action="Gérer" />
              <SectionRow icon={KeyIcon} title="Code de sécurité" desc="Utilisez un code de sécurité pour vos opérations sensibles." action="Voir" />
            </div>

            <div className="sec-help-box">
              <span className="sec-help-icon">
                <HelpIcon />
              </span>
              <div className="sec-help-copy">
                <strong>Besoin d'aide ?</strong>
                <span>Si vous remarquez une activité suspecte sur votre compte ou si vous avez besoin d'assistance, notre équipe est là pour vous aider.</span>
              </div>
              <button type="button" className="sec-help-btn">Contacter le support</button>
            </div>
          </article>
        </section>

        <aside className="sec-sidebar">
          <article className="sec-side-card">
            <div className="sec-side-head">
              <h3>Aperçu de la sécurité</h3>
            </div>
            <ShieldBackdrop />
            <div className="sec-secure-copy">
              <strong>Votre compte est sécurisé</strong>
              <span>Toutes les mesures de sécurité recommandées sont activées.</span>
            </div>
            <ul className="sec-checklist">
              <li><CheckCircleIcon /> Mot de passe sécurisé</li>
              <li><CheckCircleIcon /> Authentification à deux facteurs</li>
              <li><CheckCircleIcon /> Aucun accès suspect détecté</li>
              <li><CheckCircleIcon /> Informations à jour</li>
            </ul>
            <div className="sec-tip">
              <span className="sec-tip-icon">
                <HelpIcon />
              </span>
              <div className="sec-tip-copy">
                <strong>Conseil sécurité</strong>
                <span>Ne partagez jamais votre mot de passe et activez toujours la 2FA.</span>
              </div>
            </div>
          </article>

          <article className="sec-side-card">
            <div className="sec-side-head sec-side-head-row">
              <h3>Activité récente</h3>
              <a href="/">Voir tout</a>
            </div>
            <div className="sec-activity-list">
              <ActivityItem icon={CardIcon} title="Connexion réussie" location="Douala, Cameroun" time="Aujourd'hui, 08:45" status="Cet appareil" tone="green" />
              <ActivityItem icon={CardIcon} title="Connexion réussie" location="Yaoundé, Cameroun" time="Hier, 21:30" status="Android" tone="blue" />
              <ActivityItem icon={LockIcon} title="Changement de mot de passe" location="Douala, Cameroun" time="12 mai 2024, 14:20" tone="violet" />
              <ActivityItem icon={WarningIcon} title="Connexion échouée" location="France" time="10 mai 2024, 19:10" status="Bloqué" tone="red" />
            </div>
          </article>
        </aside>
      </div>
    </>
  );
}
